module.exports = __webpack_public_path__ + "img/1-lg.67ed32bd.jpg";